const Media = {
	GITHUB: 'https://github.com/joelorzet',
	LINKEDIN: 'https://www.linkedin.com/in/joelorzet',
	TWITTER: 'https://twitter.com/JoelOrzet',
};

export default Media;
